module.exports = __webpack_public_path__ + "img/icon_centralizacao_de_comunicacoes.f4eacf88.svg";